import { Routes, Route, Navigate } from 'react-router-dom';
import { Home } from '@/pages/Home';
import { AiResumeBuilder } from '@/pages/AiResumeBuilder';
import { AtsResumeBuilder } from '@/pages/AtsResumeBuilder';
import { ResumeTemplates } from '@/pages/ResumeTemplates';
import { ResumeBuilderForStudents } from '@/pages/ResumeBuilderForStudents';
import { ResumeBuilderForNoExperience } from '@/pages/ResumeBuilderForNoExperience';
import { Pricing } from '@/pages/Pricing';
import { Privacy } from '@/pages/Privacy';
import { Terms } from '@/pages/Terms';
import { HowItWorks } from '@/pages/HowItWorks';
import { Contact } from '@/pages/Contact';
import { Editor } from '@/pages/Editor';
import { NotFound } from '@/pages/NotFound';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/ai-resume-builder" element={<AiResumeBuilder />} />
      <Route path="/ats-resume-builder" element={<AtsResumeBuilder />} />
      <Route path="/resume-templates" element={<ResumeTemplates />} />
      <Route path="/resume-builder-for-students" element={<ResumeBuilderForStudents />} />
      <Route path="/resume-builder-for-no-experience" element={<ResumeBuilderForNoExperience />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/create" element={<Navigate to="/app/create" replace />} />
      <Route path="/app/create" element={<Editor />} />
      <Route path="/app" element={<Navigate to="/app/create" replace />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default AppRoutes;
